import { useEffect, useState } from 'react';

import { PredefinedMilisecondsTypeEnum } from '../lib/enums';
import { calculateTimeRemaining, formatTimeRemainingHours } from '../lib/util/DateTimeHelpers';
import { NullableString } from '../lib/util/types';

interface TimeRemaining {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  hasNoRemainingTime: boolean;
  displayRemainingTime: string;
  hasAtLeast1Day: boolean;
  isRemainingTimeZero: boolean;
}

export const useTimeRemaining = (endDate: NullableString): TimeRemaining => {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [hasNoRemainingTime, setHasNoRemainingTime] = useState(false);
  const [isRemainingTimeZero, setIsRemainingTimeZero] = useState(false);

  useEffect(() => {
    if (!endDate) {
      setDays(0);
      setHours(0);
      setMinutes(0);
      setSeconds(0);
      setHasNoRemainingTime(false);
      setIsRemainingTimeZero(false);

      return;
    }

    calculateTimeRemaining(
      endDate,
      setHasNoRemainingTime,
      setDays,
      setHours,
      setMinutes,
      setSeconds,
      setIsRemainingTimeZero,
    );

    const intervalId = setInterval(() => {
      calculateTimeRemaining(
        endDate,
        setHasNoRemainingTime,
        setDays,
        setHours,
        setMinutes,
        setSeconds,
        setIsRemainingTimeZero,
      );
    }, PredefinedMilisecondsTypeEnum.oneSecond);

    return () => clearInterval(intervalId); // eslint-disable-line consistent-return
  }, [endDate]);

  const displayRemainingTime = formatTimeRemainingHours(days, hours, minutes, seconds);
  const hasAtLeast1Day = days >= 1;

  return {
    days,
    hours,
    minutes,
    seconds,
    hasNoRemainingTime,
    displayRemainingTime,
    hasAtLeast1Day,
    isRemainingTimeZero,
  };
};
